import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import TextField from "@mui/material/TextField";
import { Typography, Chip, Box, Container, useTheme } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Button from "@mui/material/Button";
import { getData, writeData } from "../functions/writeData";
import { Timestamp, doc, setDoc } from "firebase/firestore";
import { useNavigate, useParams } from "react-router-dom";
import { fireDB } from "../config";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
function getStyles(name, personName, theme) {
  return {
    fontWeight:
      personName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}
const today = new Date();
const tomorrow = new Date(today);
tomorrow.setDate(today.getDate() + 1);

export default function AddCoupon() {
  const params = useParams();
  const navigate = useNavigate();
  const theme = useTheme();
  const { register, handleSubmit, setValue, watch } = useForm({
    defaultValues: {
      product_id: [],
      limit: "",
      discount: "",
      code: "",
      validity: new Date().toJSON(),
      limit: "",
    },
  });

  const [colData, setColData] = React.useState();

  useEffect(() => {
    collectionData();
  }, []);

  useEffect(() => {
    if (params?.item) {
      let item = JSON.parse(params.item);

      setValue("limit", item.limit);
      setValue("discount", item.discount);
      setValue("code", item.code);
      setValue("product_id", item.productId);
      setValue("type", item.type);
      setValue(
        "validity",
        new Date(
          item.validity.seconds * 1000 + item.validity.nanoseconds / 1000000
        )
          .toJSON()
          .split(".")[0]
      );
      setValue("id", item.id);
      setValue("range", item?.range);
    }
  }, [params]);

  async function collectionData() {
    let data = await getData("products");
    setColData(data);
  }

  const handleChange = (event) => {
    setValue(event.target.name, event.target.value);
  };

  const handleMultiple = (event) => {
    const {
      target: { value },
    } = event;

    setValue(
      "product_id",
      typeof value === "string" ? value.split(",") : value
    );
  };

  const onSubmit = async (data) => {
    let body = {
      limit: data.limit,
      discount: data.discount,
      code: data.code,
      validity: Timestamp.fromDate(new Date(data.validity)),
      productId: data.product_id?.map((row) => doc(fireDB, "products/" + row)),
      coords: {
        latitude: data?.type?.split(",")[0],
        longitude: data?.type?.split(",")[1],
      },
      range: data?.range,
      status: true,
      users: [],
    };

    if (data.id) {
      await setDoc(doc(fireDB, "coupons", data.id), body);
      alert("the coupon is set successfully");
      navigate("/dashboard/coupons");
    } else {
      await writeData("coupons", body);
      alert("the coupon is added successfully");
      navigate("/dashboard/coupons");
    }
  };

  return (
    <Container
      sx={{
        justifyContent: "center",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
      maxWidth="sm"
    >
      <Typography variant="h5" gutterBottom sx={{ fontWeight: "bold" }}>
        Add a Coupon
      </Typography>
      <form onSubmit={handleSubmit(onSubmit)}>
        <FormControl fullWidth sx={{ my: 1 }}>
          <InputLabel id="demo-simple-select-label">Select Location</InputLabel>
          <Select
            name="type"
            label="Select Location"
            {...register("type")}
            value={watch("type")}
            onChange={handleChange}
          >
            <MenuItem value={"43.639478,-79.563069"}>
              1 Eva Road, Suite 108, Etobicoke, ON, M9C 4Z5
            </MenuItem>
            <MenuItem value={"43.361472,-79.791369"}>
              3390 S Service Rd, unit 101 Burlington, ON L7N 3J5 Canada
            </MenuItem>
            <MenuItem value={"43.756078,-79.275739"}>
              1225 Kennedy Rd unit D &amp; E, Scarborough, ON M1P 4Y1
            </MenuItem>
          </Select>
        </FormControl>
        <TextField
          name="limit"
          sx={{ my: 1 }}
          fullWidth
          label="Enter Discount Limit"
          color={"primary"}
          {...register("limit")}
          value={watch("limit")}
          onChange={handleChange}
        />
        <FormControl fullWidth sx={{ my: 1 }}>
          <InputLabel id="demo-simple-select-label">Select Product</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            name="product_id"
            label=" Select Product"
            {...register("product_id")}
            value={watch("product_id")}
            onChange={handleMultiple}
            multiple
            renderValue={(selected) => (
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                {selected.map((value) => (
                  <Chip key={value} label={value} />
                ))}
              </Box>
            )}
            MenuProps={MenuProps}
          >
            {colData?.map((item, index) => (
              <MenuItem
                value={item.id}
                key={index}
                style={getStyles(item.id, watch("product_id"), theme)}
              >
                {item?.data?.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <TextField
          name="code"
          fullWidth
          label="Code"
          color="primary"
          sx={{ my: 1 }}
          {...register("code")}
          value={watch("code")}
          onChange={handleChange}
        />
        <TextField
          name="discount"
          fullWidth
          label="Discount (in percent)"
          sx={{ my: 1 }}
          color="primary"
          {...register("discount")}
          value={watch("discount")}
          onChange={handleChange}
        />
        <TextField
          name="range"
          fullWidth
          label="Range (in meters)"
          sx={{ my: 1 }}
          color="primary"
          {...register("range")}
          value={watch("range")}
          onChange={handleChange}
        />

        <TextField
          label="Validity"
          type="datetime-local"
          value={watch("validity")}
          name="validity"
          onChange={handleChange}
          sx={{ my: 1 }}
          fullWidth
          InputLabelProps={{
            shrink: true,
          }}
          inputProps={{
            min: tomorrow.toJSON().split(".")[0],
            step: "any",
          }}
        />

        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <Button
            type="submit"
            variant="contained"
            sx={{
              marginTop: 5,
              marginBottom: 10,
              backgroundColor: "#E4780E",
              fontSize: "18px",
              fontWeight: "bold",
            }}
          >
            Add Coupon
          </Button>
        </Box>
      </form>
    </Container>
  );
}
